export const isSomeEnum =
  <T extends {}>(e: T) =>
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  (token: any): token is T[keyof T] => {
    return Object.values(e).includes(token as T[keyof T]);
  };
